import { MouseEvent, useCallback, useRef, WheelEvent } from 'react';
import { Button, HStack, Text } from 'components/ui';
import { useAiEditorContext } from '../ai-editor.context';
import { AiBlockWrapper } from './styled';
import { AiConstantsItem } from '../ai-editor.types';

export const AiEditorStyles = () => {
  const {
    hasStyles,
    activeMode,
    currentStyle,
    handleStyleSelect,
    isGenerating,
  } = useAiEditorContext();

  const scrollRef = useRef<HTMLDivElement>(null);

  const handleWheel = useCallback((e: WheelEvent) => {
    if (!scrollRef.current) {
      return;
    }

    // Определяем основное направление скролла по модулю дельты
    const isHorizontalScroll = Math.abs(e.deltaX) > Math.abs(e.deltaY);
    
    // Для горизонтального скролла (тачпад) - ничего не делаем, браузер сам обработает
    if (isHorizontalScroll) {
      return;
    }

    e.preventDefault();
    scrollRef.current.scrollLeft += e.deltaY > 0 ? 50 : -50;
  }, []);

  const handleClick = (
    event: MouseEvent<HTMLButtonElement>,
    style: AiConstantsItem
  ) => {
    if (isGenerating) {
      return;
    }

    handleStyleSelect(style.value);
    event.currentTarget.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center',
    });
  };

  if (!hasStyles) {
    return null;
  }

  return (
    <AiBlockWrapper>
      <Text variant="heading-4" color="gray.500">
        Стиль
      </Text>

      <HStack
        ref={scrollRef}
        onWheel={handleWheel}
        spacing="xs"
        style={{ maxWidth: '100%', overflowX: 'auto', scrollbarWidth: 'none' }}
      >
        {activeMode?.children?.map((style) => (
          <Button
            key={style.value}
            leftIcon={<>{style.emoji}</>}
            size="s"
            mode="neutral"
            variant="main"
            selected={currentStyle === style.value}
            onClick={(event) => handleClick(event, style)}
            style={{ minWidth: 'fit-content' }}
          >
            {style.text}
          </Button>
        ))}
      </HStack>
    </AiBlockWrapper>
  );
};
